import React from "react";
import { Stack, Tooltip, Box } from "@mui/material";
import TrashImage from "../../Resources/CommonTable/delete.png";
import EditImage from "../../Resources/CommonTable/edit.png";
import ViewImage from "../../Resources/CommonTable/view.png";
import BlockImage from "../../Resources/CommonTable/Block.png";

const DynamicActions = ({
  row,
  handleView,
  handleEdit,
  handleDelete,
  handleApprove,
}) => {
  // Define actions based on row data
  const actions = [
    {
      id: "view",
      label: "View",
      icon: ViewImage,
      onClick: () => handleView(row),
      visible: row?.isView,
    },
    {
      id: "edit",
      label: "Edit",
      icon: EditImage,
      onClick: () => handleEdit(row),
      visible: row?.isEdit,
    },
    {
      id: "approve",
      label: "Approve",
      icon: BlockImage,
      onClick: () => handleApprove(row),
      visible: row?.isApprove,
    },
    {
      id: "delete",
      label: "Delete",
      icon: TrashImage,
      onClick: () => handleDelete(row),
      visible: row?.isDelete,
    },
  ];

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
    >
      {actions.map(
        (action) =>
          action.visible && (
            <Tooltip key={action.id} title={action.label}>
              <Box
                onClick={action.onClick}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={action.icon}
                  alt={`${action.label}-icon`}
                  height="16px"
                  width="16px"
                />
              </Box>
            </Tooltip>
          )
      )}
    </Stack>
  );
};

export default DynamicActions;
